import React, { useState } from "react";
import UniversalCardComponent from "../UniversalComponents/UniversalCardComponent";
import DynamicAddTaskPodModal from "./DynamicAddTaskPodModal";
import TaskRadioButton from "../UniversalComponents/CompletionCheckbox";
import { useUpdateTaskCompletionMutation } from "../../utils/customer/customerTaskTable";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";

const SubTaskListSubDrawer = ({ SubTaskslist, handleSubTaskCardClick, setSubTaskList, refetch }) => {
  const [searchText, setSearchText] = useState("");
  const [completedTasks, setCompletedTasks] = useState([]);
  const [updateCounter, setUpdateCounter] = useState(0);

  const [updateTaskCompletion, { isFetching: isTaskCompletionUpdating }] = useUpdateTaskCompletionMutation();

  const dispatch = useDispatch();

  const toggleStatus = (value) => {
    if (value === "Completed") return "Not Started";
    return "Completed";
  };

  const handleClickCompleted = (e, id, task_status_id, taskData) => {
    e.stopPropagation();
    setUpdateCounter((prevCounter) => prevCounter + 1);
    setCompletedTasks((prevTasks) => ({
      ...prevTasks,
      [id]: {
        task_status_id: !prevTasks[id] ? task_status_id : null,
        status: toggleStatus(!prevTasks[id] ? taskData?.status : prevTasks[id]?.status),
      },
    }));

    const updatedTasks = {
      ...completedTasks,
      [id]: {
        task_status_id: !completedTasks[id] ? task_status_id : null,
        status: toggleStatus(!completedTasks[id] ? taskData?.status : completedTasks[id]?.status),
      },
    };

    const CompleteData = {
      task_id: Object.keys(updatedTasks).filter((key) => updatedTasks[key]?.status === "Completed"),
      task_status_id: Object.keys(updatedTasks)
        .filter((key) => updatedTasks[key]?.status === "Completed")
        .map((key) => updatedTasks[key]?.task_status_id),
      updates: {
        status: "Completed",
      },
    };

    const NotStartedData = {
      task_id: Object.keys(updatedTasks).filter((key) => updatedTasks[key]?.status === "Not Started"),
      task_status_id: Object.keys(updatedTasks)
        .filter((key) => updatedTasks[key]?.status === "Not Started")
        .map((key) => updatedTasks[key]?.task_status_id),
      updates: {
        status: "Not Started",
      },
    };

    const completedPayload = {
      data: CompleteData,
    };

    const NotStartedPayload = {
      data: NotStartedData,
    };

    const revertCompletionChanges = () => {
      setCompletedTasks({});
    };

    const updateApi = async () => {
      const apiResponseCompleted =
        Object.keys(completedPayload?.data?.task_id)?.length && (await updateTaskCompletion(completedPayload).unwrap());
      const apiResponseNS =
        Object.keys(NotStartedPayload?.data?.task_id?.filter((key) => key))?.length &&
        (await updateTaskCompletion(NotStartedPayload).unwrap());

      if (apiResponseCompleted?.success || apiResponseNS?.success) {
        dispatch(pushAlert({ type: "success", message: "Task updated successfully", visible: true }));

        refetch();
      } else {
        dispatch(pushAlert({ type: "danger", message: "Task Not updated", visible: true }));
        revertCompletionChanges();
      }
    };

    dispatch(
      pushAlert({
        type: "revert",
        message: "",
        visible: true,
        counter: updateCounter,
        onConfirm: updateApi,
        onRevert: revertCompletionChanges,
      })
    );
  };

  const TaskCompletionCheckbox = ({ id, task_status_id, taskData, isChecked }) => {
    console.log(id, task_status_id, taskData, isChecked, "isCheckedVInsy");
    return (
      <div
        className={`flex items-center text-black ${isChecked ? "" : ""}`}
        onClick={(e) => handleClickCompleted(e, id, task_status_id, taskData)}
      >
        <TaskRadioButton isChecked={isChecked} />
      </div>
    );
  };

  const handleRowClick = (item) => {
    setSubTaskList(false);
    handleSubTaskCardClick(item);
  };

  const isMyTaskCompleted = (status, id) => {
    if (completedTasks[id] ? completedTasks[id]?.status === "Completed" : status === "Completed") {
      return true;
    }
    return false;
  };

  return (
    <div className="w-full h-full bg-white overflow-y-auto thinscrollbar p-2">
      {Array.isArray(SubTaskslist) &&
        SubTaskslist?.map((item) => (
          <div
            key={item?.id}
            className={`w-full min-h-0 grow cursor-pointer mb-2 border-[#D2DAE1] `}
            onClick={() => handleRowClick(item)}
          >
            <UniversalCardComponent
              item={item}
              searchValue={searchText}
              TaskCompletionCheckbox={TaskCompletionCheckbox}
              isSubTask={SubTaskslist.length}
              isCheckBoxShow
              isTaskCompleted={isMyTaskCompleted(item?.status, item?.id)}
              isActionsShow
              isReccurenceShow
              isTagsShow
            />
          </div>
        ))}
    </div>
  );
};

export default SubTaskListSubDrawer;
